import { savedCartName } from '@/utils/savedCartName'

export default {
  data() {
    return {
      savingCart: false,
    }
  },
  methods: {
    async saveCart() {
      const cart = this.$store.state.cart
      if (this.savingCart || !cart?.id) return

      this.savingCart = true
      const name =
        savedCartName(cart.order_variants, (count, params) =>
          this.$tc('components.saveCart.defaultName', count, params)
        ) || this.$options.filters.dateFormat(new Date(), 'P')

      try {
        await this.$orderService.saveOrder(cart.id, { name })
        this.$swalCustomSuccess(
          this.$t('components.headerCart.saveCartSuccessTitle'),
          this.$t('components.headerCart.saveCartSuccessMessage')
        )
      } catch (error) {
        this.$swalErrorMessage(error)
      } finally {
        this.savingCart = false
      }
    },
  },
}
